import { z } from 'zod';
import type { IconName } from '@/components/Icon/iconMap';
import { type IssueStatus, IssueStatus as IS, type IssueStatusFilter } from './-query/type';
const issueStatusValues = Object.values(IS) as [IssueStatus, ...IssueStatus[]];
export const IssueStatusFilterSchema = z.enum(['ALL', ...issueStatusValues]);

/**
 * 一覧画面のタブとして表示するステータス + ALL。
 * IssueStatus の `resolved` / `dismissed` は内部値として保持するが、
 * タブには表示しない。
 */
export const STATUS_TABS = [IS.UNTOUCHED, IS.IN_PROGRESS, IS.BACKLOG, IS.WAITING_REPRODUCTION, 'ALL'] as const satisfies readonly IssueStatusFilter[];
export function buildIssueTabChangeSearch(tab: string) {
  const result = IssueStatusFilterSchema.safeParse(tab);
  return {
    status: result.success ? result.data : IS.UNTOUCHED,
    pageIndex: 0,
    sortColumn: undefined,
    orderDirection: 'desc' as const
  };
}
export const TAB_TO_ICON: Record<IssueStatusFilter, IconName | null> = {
  ALL: null,
  [IS.UNTOUCHED]: 'AlertTriangleIcon',
  [IS.IN_PROGRESS]: 'ConstructionIcon',
  [IS.BACKLOG]: 'Inventory',
  [IS.WAITING_REPRODUCTION]: 'UserRoundCheckIcon',
  // タブには出ないが、Record の網羅性のため定義
  [IS.RESOLVED]: 'Check',
  [IS.DISMISSED]: 'Trash2Icon'
};